import { combineReducers } from 'redux'

import { reducer as addProjects } from './addProjects'
import { reducer as getAllProjects } from './getAllProjects'
import { reducer as getFiltredProjects } from './filtredProject'

export default combineReducers({
    addProjects,
    getAllProjects,
    getFiltredProjects,
})
